/**
 * @generated SignedSource<<3bdde710ff1ff99eacd9d7d773a06e2b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EmployeeScheduleEditScheduleListItemAssignedScheduleType_employeeScheduleType$data = {
  readonly color: string | null;
  readonly id: string;
  readonly title: string;
  readonly " $fragmentType": "EmployeeScheduleEditScheduleListItemAssignedScheduleType_employeeScheduleType";
};
export type EmployeeScheduleEditScheduleListItemAssignedScheduleType_employeeScheduleType$key = {
  readonly " $data"?: EmployeeScheduleEditScheduleListItemAssignedScheduleType_employeeScheduleType$data;
  readonly " $fragmentSpreads": FragmentRefs<"EmployeeScheduleEditScheduleListItemAssignedScheduleType_employeeScheduleType">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EmployeeScheduleEditScheduleListItemAssignedScheduleType_employeeScheduleType",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    }
  ],
  "type": "EmployeeScheduleType",
  "abstractKey": null
};

(node as any).hash = "c030f894923ce5207327367ea5e07d82";

export default node;
